import FlakyIcon from "@mui/icons-material/Flaky";
import React from "react";

const Score = [
  ["Score", "/Layout/Score", <FlakyIcon sx={{ fontSize: "2rem" }}></FlakyIcon>],
];

export default Score;
